import Resource from '@/api/resources/Resource'

class OperationConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/operations`, filterModel, { params })
        return response.data
    }
}

export default new OperationConfigurationServices()
